<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getCertificate">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal" for="name">Certificate Number</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input 
                        v-model="search.certificate_number" 
                        type="text" 
                        class="form-control"
                        placeholder="Certificate Number" 
                        aria-label="Certificate Number" 
                        aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal" for="name">Invoice Number</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input 
                        v-model="search.invoice_number" 
                        type="text" 
                        class="form-control" 
                        placeholder="Invoice Number" 
                        aria-label="Invoice Number" 
                        aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal" for="name">Invoice Date</label>
                    <Datepicker 
                      v-model="search.invoice_date" 
                      range
                      format="dd MMM yyyy"/>
                  </div>
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal" for="name">Faktur Number</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input 
                        v-model="search.faktur_number" 
                        type="text" 
                        class="form-control" 
                        placeholder="Faktur Number" 
                        aria-label="Faktur Number" 
                        aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal" for="name">Faktur Date</label>
                    <Datepicker 
                      v-model="search.faktur_date" 
                      range
                      format="dd/MM/yyyy"/>
                  </div>
                  <div class="col-12 col-sm-2">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Certificate Status</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <select v-model="search.certificate_state" class="form-select form-select-sm" >
                        <option v-for="(value, key) in CertStatusOptions" :key="key" :value="key">{{ value }}</option>
                      </select>
                    </div>
                    
                  </div>
                  <div class="col-12 col-sm-2">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Payment Status</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <select v-model="search.payment_state" class="form-select form-select-sm" >
                        <option v-for="(value, key) in PaymentStatusOptions" :key="key" :value="key">{{ value }}</option>
                      </select>
                    </div>
                    
                  </div>
                  <div class="col-12 col-sm-2 align-self-top pt-4">
                    <button type="submit" class="btn btn-primary mb-0 justify-content-center" style="width: 50px;" @click="resetOffset">
                      <i class="fa fa-search"></i>
                    </button>

                    <!-- Adding margin to create space -->
                    <button class="btn btn-primary mb-0 justify-content-center" style="width: 50px; margin-left: 5px;" @click="clearSearch">
                      <i class="fa fa-times-circle"></i>
                    </button>

                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-between">
                <div class="d-grip gap-2 d-flex">
                  <router-link to="/certificate/create">
                    <button class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Create</button>
                  </router-link>
                  <!-- <button class="btn btn-xs btn-outline-primary"><i class="fa fa-download"></i> Download</button> -->
                </div>
                <div class="d-flex">
                  <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                  <argon-pagination color="gradient-primary" size="sm">
                    <argon-pagination-item
                    @click="prevPage"
                      prev
                      :disabled="offset === 0 ? true : false" />
                    <argon-pagination-item
                      @click="nextPage"
                      next
                      :disabled="record_more === false ? true : false" />
                  </argon-pagination>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                    <thead>
                        <tr class="bg-light">
                            <!-- <th class="text-uppercase text-xxs font-weight-bolder ps-2 pt-3"><input type="checkbox" class="mb-0"/></th> -->
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Certificate Number</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Invoice Number</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Invoice Date</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Faktur Number</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Faktur Date</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Total Payment</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Status</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Bill Status</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Payment Status</th>
                            <th></th>
                        </tr>
                    </thead>
                  <tbody>
                    <tr v-for="(line, i) in certificate" :key="i">
                      <!-- <td class="w-5">
                        <input type="checkbox" class="mb-0"/>
                      </td> -->
                      <td>
                        <router-link :to="'/certificate/' + line.id" class="text-xs text-primary font-weight-bold mb-0">
                            {{ line.certificate_number }}
                        </router-link>
                      </td>
                      <td>
                          <p class="mb-0 text-xs">{{ line.invoice_number }}</p>
                      </td>
                      <td>
                          <p class="mb-0 text-xs">{{ line.invoice_date }}</p>
                      </td>
                      <td>
                          <p class="mb-0 text-xs">{{ line.faktur_number }}</p>
                      </td>
                      <td>
                          <p class="mb-0 text-xs">{{ line.faktur_date }}</p>
                      </td>
                      <td class="text-end">
                          <p class="mb-0 text-xs">{{ line.amount_total }}</p>
                      </td>
                      <td>
                          <argon-badge color="secondary" size="sm" v-if="line.state == 'Draft'">{{ line.state }}</argon-badge>
                          <argon-badge color="success" size="sm" v-else-if="line.state == 'Validated'">{{ line.state }}</argon-badge>
                          <argon-badge color="warning" size="sm" v-else-if="line.state == 'Cancelled'">{{ line.state }}</argon-badge>
                          <argon-badge color="primary" size="sm" v-else>{{ line.state }}</argon-badge>
                      </td>
                      <td>
                          <argon-badge color="secondary" size="sm" v-if="line.bill_state == 'Draft'">{{ line.bill_state }}</argon-badge>
                          <argon-badge color="warning" size="sm" v-else-if="line.bill_state == 'Cancelled'">{{ line.bill_state }}</argon-badge>
                          <argon-badge color="primary" size="sm" v-else>{{ line.bill_state }}</argon-badge>
                          
                      </td>
                      <td>
                          <argon-badge color="secondary" size="sm" v-if="line.payment_state == 'Draft'">{{ line.payment_state }}</argon-badge>
                          <argon-badge color="warning" size="sm" v-else-if="line.payment_state == 'Cancelled'">{{ line.payment_state }}</argon-badge>
                          <argon-badge color="primary" size="sm" v-else>{{ line.payment_state }}</argon-badge>
                          
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!certificate.length > 0 && !loading"/>
              <loading-state v-if="loading"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "certificate",
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    ArgonBadge,
    EmptyState,
    LoadingState,
  },
  data() {
    return {
      search: {
          certificate_number: null,
          invoice_number: null,
          invoice_date: [],
          faktur_number: null,
          faktur_date: [],
          certificate_state: null,
          payment_state: null
      },
      certificate: [],
      loading: false,
      total_data: 0,
      current_total_data: 0,
      current_page: 0,
      offset: 0,
      record_more: false,
      CertStatusOptions: {
        'draft': 'Draft',
        'submit': 'Submitted',
        'validate': 'Validated',
        'cancel': 'Cancelled'
      },
      PaymentStatusOptions: {
        'Pending Payment': 'Pending Payment',
        'In Payment': 'In Payment',
        'Partially Paid': 'Partially Paid',
        'Paid': 'Paid'
      }
    };
  },
  methods: {
    prevPage() {
      if (this.offset > 0) {
        this.offset = this.offset - 10
        this.getCertificate()
      }
    },
    nextPage() {
      if (this.record_more === true) {
        this.offset = this.offset + 10
        this.getCertificate()
      }
    },
    getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date) {
              let month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
              let fullDate = date.getFullYear() + '-' + month + '-' + date.getDate()
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
    getCertificate() {
      this.loading = true
      this.certificate = []
      this.total_data = 0
      this.current_total_data = 0
      this.record_more = false
      this.current_page = 0
      let invoice_date = this.getDate(this.search.invoice_date)
      let faktur_date = this.getDate(this.search.faktur_date)
      const values = {
        certificate_number: this.search.certificate_number,
        invoice_number: this.search.invoice_number,
        invoice_start_date: invoice_date.length > 0 ? invoice_date[0] : null,
        invoice_end_date:  invoice_date.length > 1 ? invoice_date[1] : null,
        faktur_number: this.search.faktur_number,
        faktur_start_date: faktur_date.length > 0 ? faktur_date[0] : null,
        faktur_end_date:  faktur_date.length > 1 ? faktur_date[1] : null,
        certificate_state: this.search.certificate_state,
        payment_state: this.search.payment_state,
        partner_id: localStorage.getItem("partner_id"),
        limit: 10,
        offset: this.offset
      }
      this.axios
        .post(
          endpoint.CERTIFICATE_LIST,
          values,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.certificate = response.data.data;
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    },
    clearSearch(){
          this.search.certificate_number = null;
          this.search.invoice_number = null;
          this.search.invoice_date = [];
          this.search.faktur_number = null;
          this.search.faktur_date = [];
          this.search.certificate_state = null;
          this.search.payment_state = null;
    },
    resetOffset(){
      this.offset = 0
    }
  },
  mounted() {
    this.getCertificate()
  }
};
</script>

<style>

</style>